/**
 * Checkable — checkbox + label row. Used for "I agree to the Terms"
 * and similar opt-ins. Coral-fill when checked, ink hairline border
 * when unchecked. The whole row is the hit target — important for
 * "Send me product updates" sub-rows where the label is multi-line.
 */
import { ReactNode } from 'react';
import { Icons } from './Icons';

type Props = {
  checked: boolean;
  onChange: () => void;
  muted?: boolean;
  children: ReactNode;
};

export function Checkable({ checked, onChange, muted, children }: Props) {
  return (
    <button
      type="button"
      onClick={onChange}
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        textAlign: 'left',
        padding: 2,
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
      }}
    >
      <div
        style={{
          width: 22,
          height: 22,
          borderRadius: 7,
          border: `1.5px solid ${checked ? 'var(--coral)' : 'var(--line-strong)'}`,
          background: checked ? 'var(--coral)' : 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          flexShrink: 0,
          transition: 'all 0.2s',
        }}
      >
        {checked && <Icons.check size={13} stroke={3.2} />}
      </div>
      <div style={{ fontSize: 13, color: muted ? 'var(--ink-3)' : 'var(--ink-2)', lineHeight: 1.5 }}>
        {children}
      </div>
    </button>
  );
}
